<template lang="pug">
  .catalog
    .columns.is-gapless.has-background-white
      .column.is-narrow.items
        .item(v-for="item in items" @click="$emit('input', item)" :class="{ active: item === value }")
          slot(name="item" :item="item")
      .column
        slot(v-if="value" :item="value")
</template>

<script>
export default {
  name: 'catalog',

  props: {
    items: {
      required: true,
    },
    value: null,
  },
};
</script>

<style lang="scss" scoped>
@import '~bulma/sass/utilities/_all';

.items {
  border-right: 1px solid $light;
}

.items .item {
  width: 15vw;
  padding: 20px;
  cursor: pointer;
}

.items .item:hover {
  background-color: $light;
}

.items .item.active {
  background-color: $primary;
}
</style>
